module.exports = __webpack_public_path__ + "img/stars.b91a796e.svg";